import React from "react";
import { useSelector, useDispatch } from "react-redux";
import styled from "styled-components";

import { addMobileClass } from "../../lib/utils";
import { isNarrowScreen } from "../../lib/constants";
import { closeGallery } from "./actions";
import { GalleryCloseIcon, GalleryMobileCloseIcon } from "../../lib/icons";

/**
 * Button that closes the gallery.
 */
export const CloseGalleryButton = () => {
  const dispatch = useDispatch();

  return (
    <Button onClick={(e) => dispatch(closeGallery())} className={addMobileClass()}>
      {isNarrowScreen ? <GalleryMobileCloseIcon /> : <GalleryCloseIcon />}
    </Button>
  );
};

const Button = styled.div`
  position: absolute;
  width: 28px;
  height: 28px;
  right: 60px;
  top: 60px;
  cursor: pointer;
  z-index: 4;
  transition: all 0.2s ease-out;
  //filter: drop-shadow(0 2px 2px #1a1a1a);
  color: #141233;

  &:hover {
    transform: scale(1.1);
    color: ${(props) => props.theme.brandColor || "#337ab7"};
  }

  &.mobile {
    right: 15px;
    top: 15px;
    width: auto;
    height: auto;
  }
`;
